// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { mantleSepoliaTestnet as _mantleSepoliaTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the mantleSepoliaTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 5003
 * Chain Name: Mantle Sepolia Testnet
 * Default Block Explorer: https://explorer.sepolia.mantle.xyz/
 * Default RPC URL: https://rpc.sepolia.mantle.xyz
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { mantleSepoliaTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: mantleSepoliaTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const mantleSepoliaTestnet = createCommon({
	..._mantleSepoliaTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
